import angular from "angular";

angular
    .module('organizationsControl.payment', [])
    .service('Payment', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/payments';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.store = function (params) {
            return $http.post(uri(), params);
        };
    }]);

export default 'organizationsControl.payment';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/payment.js